export default __webpack_public_path__ + "static/media/compass.9980ed98.svg";